import { combineReducers } from "redux";

import * as config from "./config";
import * as merchant from "./merchant";
import * as userInput from "./userInput";

export const reducer = combineReducers({
  config: config.reducer,
  merchant: merchant.reducer,
  userInput: userInput.reducer,
});

export interface StoreState {
  config: config.StoreState;
  merchant: merchant.StoreState;
  userInput: userInput.StoreState;
}
